import React from "react"
import { useProjectStore } from "stores/projectStore"

/**
 * Renders the status of a project.
 *
 * This component displays the current status of a project along with
 * additional information such as awaiting data and reporting.
 *
 * @component
 * @returns  The rendered ProjectStatus component.
 */
const ProjectStatus: React.FC = () => {
  const project = useProjectStore((state) => state.project)

  return (
    <p>Current project status: {project.Status} | Awaiting data | Reporting</p>
  )
}

export default ProjectStatus
